<template>
  <div class="container">
    <div class="card">
      <img src="/images/logo-font-white.svg" alt="Yuzu logo" />
      <img
        src="@/assets/images/illustration/maintenance/game-maintenance.svg"
      />
      <div class="title">
        Nous sommes actuellement en cours de
        <span class="primary-color">maintenance</span>.
      </div>
      <p>
        Pour des raisons techniques, la plateforme est actuellement
        inaccessible, mais rassurez vous, on revient très vite !
      </p>
    </div>
  </div>
</template>
